import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box, Button,
    Checkbox,
    Divider,
    Fade, FormControl, FormControlLabel, FormGroup, Grid,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Modal,
    Popover,
    Radio,
    RadioGroup,
    Select,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React, { useMemo, useRef, useState } from 'react';
import { ReactComponent as DeleteIcon } from "../assets/icons/icon-delete.svg";
import { ReactComponent as HashtagIcon } from "../assets/icons/icon-hashtag.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/icon_close.svg";
import { ReactComponent as EditIcon } from "../assets/icons/icon_edit.svg";
import DashboardGranularity from '../components/_report/dashboard/DashboardGranularity';
import FormatControl from '../components/_reportDashboardFilter/FormatControl';
import ReportDashboardFilterForm from '../components/_reportDashboardFilter/ReportDashboardFilterForm';
import { CustomSwitch, CustomTooltip } from '../utils/Reusables';
import { useDashboardContext } from '../layouts/dashboardView/DashboardView';
import { ReactComponent as IconFilterDelete } from "../assets/icons/icon-delete2-small.svg";
import { ReactComponent as IconFilterDrag } from "../assets/icons/icon-report-filter-drag.svg";
import { ReactComponent as IconFilterSetting } from "../assets/icons/icon-report-filter-setting.svg";
import { ReactComponent as DropDownIcon } from "../assets/icons/icon-angle-down.svg";

const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        flexShrink: 0,
    },
}));

const useStyles = makeStyles((theme) => ({
    bgWhite: {
        backgroundColor: '#fff',
        borderRadius: '4px',
    },
    formInput: {
        paddingLeft: 0,
        '&::placeholder': {
            paddingLeft: '-10px',
        }
    },
    searchFieldListItem: {
        paddingTop: '0.6rem',
        paddingBottom: '0.6rem',
        '&:hover': {
            background: "#f1f1f1",
            backgroundColor: "#f1f1f1",
            zIndex: 9,
            "& $listItemDescription": {
                visibility: 'visible'
            },
            "& $searchFieldListMoreIcon": {
                visibility: 'visible'
            }
        },

    },
    listItemDescription: {
        visibility: 'visible',
        '&:hover': {
            visibility: 'visible'
        }
    },
    searchFieldListMoreIcon: {
        visibility: 'visible',
        '&:hover': {
            visibility: 'visible'
        }
    }
}));

export default function ReportDashboardFilterNew({
    filterFormState,
    setFilterFormState,
    valueList,
    granularityOptions,
    addGranularityToSheet,
    sheetsAvailable,
    setSheetsAvailable,
    selectedSheetIndex,
    applyGranularityToAllReports,
    removeGranularityFrmAllReports
}) {
    const { currentSheet, updateSheet, dashboardState, updateSheetFilter } = useDashboardContext();
    const [anchorAddFilter, setAnchorAddFilter] = useState(null);
    const [filterFormOpen, setFilterFormFilter] = useState(-1);
    const [openPopup, setOpenPopup] = useState(false);
    const [recordForEdit, setRecordForEdit] = useState(null)
    const [deletePopup, setDeletePopup] = useState(false)
    const [deleteAllPopup, setDeleteAllPopup] = useState(false)
    const [filterButtonWidth, setFilterButtonWidth] = useState('200px')
    const [deleteObj, setDeleteObj] = useState({})
    const buttonRef = useRef();
    const classes = useStyles();
    const [isFilterexpanded, setIsFilterExpanded] = useState(false);
    const [addToReportPopup, setAddToReportPopup] = useState(false);
    const [addToReportFilterCategory, setAddToReportFilterCategory] = useState(null);
    const [addToReportFilterCustomFilterList, setAddToReportFilterCustomFilterList] = useState([]);

    
    const filterOptionList = useMemo(() => {
        if(currentSheet?.sheetFilter?.length === 0) setIsFilterExpanded('first-applied-filters');
        if (!currentSheet || currentSheet.reports.length === 0) return [];
        return currentSheet.reports.map(report => {
            return {
                report,
                filterOptionList: report?.reportFilters?.filter(filter => filter?._id && filter?.listType)
            }
        });
    }, [currentSheet])

    const handleEditDashboardFilter = (form) => {
        if (form) {
            let sheetFilter = structuredClone(currentSheet.sheetFilter);
            sheetFilter[form?.index].applicableTo = form?.applicableTo;
            sheetFilter[form?.index].applyTo = form?.applyTo;
            sheetFilter[form?.index].displayNameOnSheet = form?.displayNameOnSheet;
            sheetFilter[form?.index].displayType = form?.displayType;
            updateSheetFilter({ sheetFilter, sheetIndex: dashboardState.currentSheetIndex });
        }
    }

    const addFilter = (event) => {
        const buttonWidth = buttonRef.current.clientWidth;
        setFilterButtonWidth(buttonWidth);
        setAnchorAddFilter(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorAddFilter(null);
    };

    const deleteAllFilterPopUp = () => {
        setDeleteAllPopup(true)
    }


    const deleteReportFilterPopUp = (filter, index, valueList) => {
        setDeleteObj({ filter, index, valueList });
        setDeletePopup(true)
    }

    const deleteReportFilter = () => {
        let { filter, index, valueList } = deleteObj;
        const sheetFilter = structuredClone(currentSheet.sheetFilter);
        sheetFilter.splice(index, 1);
        updateSheetFilter({ sheetFilter, sheetIndex: dashboardState.currentSheetIndex });

        setDeletePopup(false)
        setDeleteObj({})
    }

    const deleteAllFilter = () => {
        updateSheetFilter({ sheetFilter: [], sheetIndex: dashboardState.currentSheetIndex });
        setDeleteAllPopup(false)
    }

    const clickMeasureListHandler = (measure, report) => {
        measure.reportId = report
        measure.reportObjId = report?._id
        const clonedSheet = structuredClone(currentSheet);
        clonedSheet.sheetFilter.push(measure);
        updateSheet({ sheet: clonedSheet, sheetIndex: dashboardState.currentSheetIndex });
        setAnchorAddFilter(null);
    }

    const addOrEdit = (form, resetForm) => {
        resetForm()
        setOpenPopup(false);
        handleEditDashboardFilter(form);
    }

    const openInPopup = (obj, i) => {
        setRecordForEdit({ ...obj, index: i })
        setOpenPopup(true)
    }

    const closeEditFilterModal = () => {
        setRecordForEdit({})
        setOpenPopup(false)
    }

    const filterFormStateChange = (type, index, value) => {

        if (type === "filterOperation") {
            filterFormState[index].operator = value;
        }
        let filterFormStateNew = [...filterFormState];
        setFilterFormState(filterFormStateNew);
    }

    const handleCancelDeleteAll = () => {
        setDeleteAllPopup(false)
    }

    const handleCancelDelete = () => {
        setDeletePopup(false)
    }

    const generateFilterList = () => {
        let filterList = []
        if (filterOptionList?.length) {
            filterList = filterOptionList?.map((reportObj, i) => {
                if (reportObj?.filterOptionList?.length) {
                    return reportObj?.filterOptionList.map(measure => (
                        <ListItem className={classes.searchFieldListItem} key={`report-filter-${i}-${reportObj.report._id}`} button onClick={() => clickMeasureListHandler(measure, reportObj?.report)}
                            alignItems="flex-start">
                            <ListItemIcon sx={{ mt: '0px', mr: '4px' }} className={classes.searchFieldListIcon}>
                                {measure?.dataSetType === "MEASURE" ? <FunctionsOutlinedIcon className="cm_dimension_icon icon_color_main" /> : <LabelOutlinedIcon className="cm_measr_lbl icon_color_main" />}
                            </ListItemIcon>
                            <Grid container>
                                <Grid xs={12}>
                                    <div className="filterlist-text">
                                        <Typography className="text-plain"> {(measure?.member ? reportObj?.report?.reportName + ' - ' + (measure?.displayName ? measure?.member.split('.')[0] + '.' + measure?.displayName : measure?.member) : (measure?.displayName || measure?.name))} </Typography>
                                        <span>{(measure?.useRelevant?.length || measure?.relevantTo) ? <CopyrightIcon /> : ''}</span>
                                    </div>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="subtitle2" className={classes.listItemDescription + " text-sub"}>{measure?.description} </Typography>
                                </Grid>
                            </Grid>
                        </ListItem>
                    ))
                } else {
                    return null
                }
            })
        }

        if (filterList.length) {
            return filterList.filter(filter => filter !== undefined && filter !== '')
        }
        else {
            return filterList
        }

    }

    const handleAccordionChange = (panel) => {
        if(isFilterexpanded === panel) {
            setIsFilterExpanded(false);
        } else {
            setIsFilterExpanded(panel ?? false);
        }
    };

    const handleAddToReportFilterCustomFilterList = (e) => {
        let updatedValue;
        if(addToReportFilterCustomFilterList?.includes(e.target.value)) {
            updatedValue = addToReportFilterCustomFilterList.toSpliced(addToReportFilterCustomFilterList?.indexOf(e.target.value), 1);
        } else {
            if(addToReportFilterCustomFilterList?.length > 0){
                updatedValue = [...addToReportFilterCustomFilterList, e.target.value];
            } else {
                updatedValue = [e.target.value];
            }
        }
        setAddToReportFilterCustomFilterList(updatedValue);
    }

    return (
        <RootStyle>
            <Box className="report-filters-section">
                <Typography variant="h5" className="filter-heading" >Filter</Typography>
                <Box height="100%" py={2} >
                    {/* <Button className="width-100 report_form_ui_btn primary" variant="contained" color="primary" startIcon={<AddIcon />} onClick={addFilter}
                        ref={buttonRef} >
                        Add Filter Condition
                    </Button>
                    <Popover
                        id="measure-list"
                        open={Boolean(anchorAddFilter)}
                        anchorEl={anchorAddFilter}
                        onClose={handleClose}
                        PaperProps={{
                            style: {
                                width: filterButtonWidth, height: 'fit-content', maxHeight: '300px', borderTopLeftRadius: 0,
                                borderTopRightRadius: 0, marginTop: '10px', backgroundColor: 'transparent'
                            },
                        }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                    >
                        <Box className="width-100">
                            <Box className="field_list report_filter_list height-fit max-width-100 mt-0" sx={{ maxHeight: '300px', backgroundColor: '#fff' }} >
                                <List component="nav" aria-label="main mailbox folders" className="field_list">
                                    {
                                        generateFilterList().length ? generateFilterList() :
                                            <ListItem button >
                                                No filters found!
                                            </ListItem>
                                    }
                                </List>
                            </Box>
                        </Box>

                    </Popover> */}
                    <Box>
                        {
                        currentSheet?.sheetFilter?.length ?
                            <List component="nav" aria-label="main mailbox folders" className="field_list" sx={{ p: 0, mt: 1 }}>
                                {currentSheet?.sheetFilter?.map((obj, i) => (
                                    <ListItem key={`sheet-filter-${i}`} sx={{ p: 0 }}>
                                        <Box display="block" width="100%" className="filter-box-item" >
                                            <Box>
                                                <Stack direction="row" width="100%" spacing={1} flexShrink={0} sx={{ my: 0 }}>
                                                    <ListItemIcon sx={{ paddingTop: '5px', marginRight: '12px' }}>
                                                        <HashtagIcon color="primary" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        sx={{ marginLeft: '0px !important' }}
                                                        className="box-col-pointer text-plain"
                                                        primary={(obj?.reportId?.reportName && (obj?.displayNameOnSheet || obj?.displayName || obj?.member?.split('.')[1]) && obj?.member ? `${obj?.reportId?.reportName} - ${(obj?.displayNameOnSheet || obj?.displayName || obj?.member?.split('.')[1])} - ${(obj?.displayName ? obj?.member.split('.')[0] + '.' + obj?.displayName : obj?.member)}` : !obj?.reportId?.reportName && (obj?.displayNameOnSheet || obj?.displayName || obj?.member?.split('.')[1]) && obj?.member ? `${(obj?.displayNameOnSheet || obj?.displayName || obj?.member?.split('.')[1])} - ${obj?.member}` : obj?.reportId?.reportName && !(obj?.displayNameOnSheet || obj?.member?.split('.')[1]) && obj?.member ? `${obj?.reportId?.reportName} - ${(obj?.displayName ? obj?.member.split('.')[0] + '.' + obj?.displayName : obj?.member)}` : obj?.reportId?.reportName && (obj?.displayNameOnSheet || obj?.displayName || obj?.member?.split('.')[1]) && !obj?.member ? `${obj?.reportId?.reportName} - ${(obj?.displayNameOnSheet || obj?.displayName || obj?.member?.split('.')[1])}` : (obj?.displayName ? obj?.member.split('.')[0] + '.' + obj?.displayName : obj?.member))}
                                                        secondary={obj?.operator}
                                                    />
                                                    {(obj?.useRelevant?.length || obj?.relevantTo ? <CopyrightIcon /> : '')}

                                                </Stack>
                                                <Stack direction="row" sx={{ mt: 2, pt: 1 }}>
                                                    <CustomTooltip title="Edit filter">
                                                        <IconButton color="primary" aria-label="Edit filter" component="span" className="hover-white form-icon-btn"
                                                            sx={{ p: 0, marginRight: 4 }}
                                                            onClick={() => openInPopup(obj, i)}>
                                                            <EditIcon className="filter-action-icon" />
                                                            <Typography variant="subtitle2" className="text-small" sx={{ pl: 1 }}>Edit</Typography>
                                                        </IconButton>
                                                    </CustomTooltip>
                                                    <CustomTooltip title="Delete filter">
                                                        <IconButton color="primary" aria-label="Delete filter" component="span" className="hover-white form-icon-btn"
                                                            sx={{ p: 0, marginRight: 4 }}
                                                            onClick={() => deleteReportFilterPopUp(obj, i, valueList)} >
                                                            <DeleteIcon className="filter-action-icon" />
                                                            <Typography variant="subtitle2" className="text-small" sx={{ pl: 1 }}>Delete</Typography>
                                                        </IconButton>
                                                    </CustomTooltip>

                                                </Stack>
                                            </Box>
                                            <Box style={{ display: filterFormOpen === i ? "block" : "none" }}>
                                                <form id={"filter" + i}>
                                                    {obj && <ReportDashboardFilterForm reportDashboardFilter={obj} i={i} filterFormStateChange={filterFormStateChange} />}
                                                </form>
                                            </Box>
                                        </Box>
                                    </ListItem>
                                ))}
                            </List>
                        
                        :   <Grid>
                                <Box className="re-dashboard-new-filters-listitem">
                                    <Accordion className="re-re-new-filters-listitem-accordion" key={`dash-applied-filters-first`} 
                                        expanded={isFilterexpanded === `first-applied-filters`} >
                                        <AccordionSummary aria-controls={`dash-applied-filters-content`} 
                                            id={`dash-applied-filters-header`} onClick={() => handleAccordionChange(`first-applied-filters`)}>
                                            <Box className="re-flex-start">
                                                <IconFilterDrag className="re-re-new-filters-listitem-drag" />
                                                <Box className="re-flex-between" data-key={`first-applied-filters`} >
                                                    <Typography component={"h4"} className='re-re-new-filters-listitem-header'>
                                                        {'New Filter'}
                                                    </Typography>
                                                    <Box className="re-flex-align-center">
                                                        <Typography className='re-re-new-filters-listitem-filter-show' component={'span'} 
                                                            onClick={(e) => {e.stopPropagation();setAddToReportPopup(true)}}>
                                                            {(isFilterexpanded === `first-applied-filters`) ? `Show on report`: `Hide`}
                                                        </Typography>
                                                        <IconFilterDelete className="re-re-new-filters-listitem-delete-filter" 
                                                            onClick={(e) => {e.stopPropagation();return false}} />
                                                        <IconFilterSetting className="re-re-new-filters-listitem-setting-filter" 
                                                            onClick={(e) => {e.stopPropagation();console.log("112")}}  />
                                                    </Box>
                                                </Box>
                                            </Box>
                                            
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container className='field-details' spacing={2.5}>
                                                <Grid item xs={12}>
                                                    <FormControl fullwidth className="re-form-group">
                                                        <Typography component={'label'} className="re-formgroup-label-sm" >Dataset</Typography>
                                                        <Select
                                                            variant="outlined"
                                                            className="report_form_ui_input_select text-small pl-0"
                                                            id={"filterOperation-dataset"}
                                                            // value={''}
                                                            // onChange={handleChangeOperator}
                                                            size='small'
                                                            IconComponent={DropDownIcon}
                                                            MenuProps={{
                                                                classes: {
                                                                    root: `form-select-menu re-form-select-menulist`
                                                                }
                                                            }}
                                                        >
                                                            {
                                                                [{label: 'Dataset 1', value: 'Dataset 1'},
                                                                {label: 'Dataset 2', value: 'Dataset 2'},
                                                                ]?.map(obj => (
                                                                    <MenuItem key={`dataset-${obj.value}`} className={classes.menuDropdownItem + " menu-item-small"} value={obj.value}>{obj.label}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    <FormControl fullwidth className="re-form-group">
                                                        <Typography component={'label'} className="re-formgroup-label-sm" >Field Name</Typography>
                                                        <Select
                                                            variant="outlined"
                                                            className="report_form_ui_input_select text-small pl-0"
                                                            id={"filterOperation-field"}
                                                            // value={''}
                                                            // onChange={handleChangeOperator}
                                                            size='small'
                                                            IconComponent={DropDownIcon}
                                                            MenuProps={{
                                                                classes: {
                                                                    root: `form-select-menu re-form-select-menulist`
                                                                }
                                                            }}
                                                        >
                                                            {
                                                                [{label: 'Field 1', value: 'Field 1'},
                                                                {label: 'Field 2', value: 'Field 2'},
                                                                ]?.map(obj => (
                                                                    <MenuItem key={`Field-${obj.value}`} className={classes.menuDropdownItem + " menu-item-small"} value={obj.value}>{obj.label}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    <FormControl fullwidth className="re-form-group">
                                                        <Typography component={'label'} className="re-formgroup-label-sm" >Field Name</Typography>
                                                        <Select
                                                            variant="outlined"
                                                            className="report_form_ui_input_select text-small pl-0"
                                                            id={"filterOperation-field"}
                                                            // value={''}
                                                            // onChange={handleChangeOperator}
                                                            size='small'
                                                            IconComponent={DropDownIcon}
                                                            MenuProps={{
                                                                classes: {
                                                                    root: `form-select-menu re-form-select-menulist`
                                                                }
                                                            }}
                                                        >
                                                            {
                                                                [{label: 'Field 1', value: 'Field 1'},
                                                                {label: 'Field 2', value: 'Field 2'},
                                                                ]?.map(obj => (
                                                                    <MenuItem key={`Field-${obj.value}`} className={classes.menuDropdownItem + " menu-item-small"} value={obj.value}>{obj.label}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    <FormControl fullwidth className="re-form-group">
                                                    <Typography component={'label'} className="re-formgroup-label-sm" >Value</Typography>
                                                        <TextField
                                                            className="report_form_ui_input text-small"
                                                            id={"operatorvalues-value"}
                                                            label=""
                                                            // value={filterValues.join('\n')}
                                                            // onChange={e => handleValuesChange(e, operator,filterObj)}
                                                            variant="outlined"
                                                            size='small'
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                            </Grid>
                        }   
                    </Box>
                    {
                        currentSheet?.sheetFilter?.length ? (<div>
                            <Stack direction="row" width="100%" spacing={1} flexShrink={0} sx={{ my: 1 }}>
                                {/* <Button width="100%" className="report_form_ui_btn primary text-btn-small mr-2" variant="contained" color="primary" onClick={applyFilter} >
                                    Apply Filter
                                </Button> */}
                                <Button width="100%" className="report_form_ui_btn primary text-btn-small" variant="contained" color="primary" onClick={deleteAllFilterPopUp}>
                                    Delete all
                                </Button>
                            </Stack>
                        </div>) : (<></>)
                    }

                    {
                    (!currentSheet?.sheetFilter || currentSheet?.sheetFilter.filter(obj => !obj.onReport).length < 1 || currentSheet?.sheetFilter.filter(obj => !obj.member).length < 1) &&
                        <Grid xs={12} sx={{marginTop: 2.5}} >
                            <Button className="re-btn re-btn-outline re-btn-full" variant="contained" color="primary" 
                                // startIcon={<AddIcon />} 
                                // onClick={onAddFilter} ref={buttonRef} 
                            >
                                + Add New Filter
                            </Button>
                        </Grid>
                    }
                </Box>

                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal-root"
                    open={openPopup}
                    onClose={() => setOpenPopup(false)}
                    closeAfterTransition
                >
                    <Fade in={openPopup}>
                        <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
                            <CloseIcon onClick={closeEditFilterModal} className="enlarge-close" />
                            <Box className="modal-header" >
                                <Typography variant="subtitle1" className="modal-header-title" >{`Edit Filter`}</Typography>

                            </Box>
                            <Box className="modal-content">
                                <FormatControl justifyContent="flex-start" addOrEdit={addOrEdit} recordForEdit={recordForEdit} />
                            </Box>

                        </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal-root"
                    open={deletePopup}
                    onClose={() => setDeletePopup(false)}
                    closeAfterTransition
                >
                    <Fade in={deletePopup}>
                        <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                            <Box className="modal-content-simple">
                                <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this Filter ?`}</Typography>
                                <Box className="modal-footer-simple">
                                    <Button onClick={handleCancelDelete} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                                    <Button onClick={deleteReportFilter} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Fade>
                </Modal>

                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal-root"
                    open={deleteAllPopup}
                    onClose={() => setDeleteAllPopup(false)}
                    closeAfterTransition
                >
                    <Fade in={deleteAllPopup}>
                        <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                            <Box className="modal-content-simple">
                                <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete all Filters ?`}</Typography>
                                <Box className="modal-footer-simple">
                                    <Button onClick={handleCancelDeleteAll} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                                    <Button onClick={deleteAllFilter} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Fade>
                </Modal>

                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal-root"
                    open={addToReportPopup}
                    onClose={() => setAddToReportPopup(false)}
                    closeAfterTransition
                >
                    <Fade in={addToReportPopup}>
                        <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
                            <CloseIcon onClick={() => setAddToReportPopup(false)} className="enlarge-close enlarge-close-lg"   />
                            <Box className="modal-header p-2" style={{borderBottom: '0', marginBottom: 0}}>
                                <Typography component={'h2'} className="modal-header-title modal-header-title-lg text-center" 
                                    id="simple-modal-title" style={{marginTop: '40px'}}
                                >Edit Filter</Typography>
                            </Box>
                            <Box className="modal-content" style={{marginTop: 0, marginBottom: 0, maxHeight: '75vh'}}>
                                <Grid container spacing={2.5} >
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <Typography component="label" className='re-formgroup-label-sm'>Filter name</Typography>
                                            <TextField 
                                                className="report_form_ui_input medium-dark text-small"
                                                id="field_name"
                                                variant="outlined"
                                                value=''
                                                onChange={(val) => {return false}}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <Typography component="label" className='re-formgroup-label-sm'>Filter type</Typography>
                                            <Select
                                                variant="outlined"
                                                className="report_form_ui_input_select medium-dark text-small pl-0"
                                                id={"filter-type"}
                                                value={''}
                                                onChange={() => {return false}}
                                                size='small'
                                                IconComponent={DropDownIcon}
                                                MenuProps={{
                                                    classes: {
                                                        root: `form-select-menu re-form-select-menulist`
                                                    }
                                                }}
                                            >
                                                {
                                                    [
                                                        {displayName: 'Filter type 1', name: 'Filter Type 1'},
                                                        {displayName: 'Filter type 2', name: 'Filter Type 2'},
                                                        {displayName: 'Filter type 3', name: 'Filter Type 3'}
                                                    ].map(obj => (
                                                        <MenuItem key={`${obj.value}`} 
                                                            className={classes.menuDropdownItem + " menu-item-small"} 
                                                            value={obj.name}>
                                                                {obj.displayName}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <Typography component="label" style={{marginBottom: 0}}
                                                className='re-formgroup-label-sm' >Filter category</Typography>
                                            <RadioGroup
                                                row
                                                name="filter-category"
                                                value={addToReportFilterCategory}
                                                onChange={e => setAddToReportFilterCategory(e.target.value)}
                                            >
                                                <FormControlLabel className="re-formcontrol-label-sm"  value="single" 
                                                    control={<Radio className="re-form-checkbox-sm" size="small" />} label="Single select" />
                                                <FormControlLabel className="re-formcontrol-label-sm"  value="multi" 
                                                    control={<Radio className="re-form-checkbox-sm" size="small" />} label="Multi-select" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <Typography component="label" style={{marginBottom: 0}}
                                                className='re-formgroup-label-sm'>Customise filter list</Typography>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    className="re-formcontrol-label-sm"
                                                    control={
                                                    <Checkbox size="small" className="re-form-checkbox-sm" 
                                                        checked={addToReportFilterCustomFilterList?.includes("Select all")} 
                                                        onChange={handleAddToReportFilterCustomFilterList} 
                                                        name="Select all" value="Select all" />
                                                    }
                                                    label="Show select all"
                                                />
                                                <FormControlLabel
                                                    className="re-formcontrol-label-sm"
                                                    control={
                                                    <Checkbox size="small" className="re-form-checkbox-sm" 
                                                        checked={addToReportFilterCustomFilterList?.includes("Specific value")} 
                                                        onChange={handleAddToReportFilterCustomFilterList} 
                                                        name="Specific value" value="Specific value" />
                                                    }
                                                    label="Specific value"
                                                />
                                                
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>

                                    {
                                        addToReportFilterCustomFilterList?.includes("Specific value")
                                            ?   <Grid item xs={12} style={{paddingTop: 0}}>
                                                    <FormControl fullWidth>
                                                        <Typography component="label" style={{fontWeight: 'normal'}}
                                                            className='re-formgroup-label-sm'>Value list</Typography>
                                                        <TextField 
                                                            className="report_form_ui_input medium-dark text-small"
                                                            id="field_name"
                                                            variant="outlined"
                                                            value=''
                                                            onChange={(val) => {return false}}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            :   null
                                    }

                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Box className="re-flex-between">
                                            <Typography component="label" style={{marginBottom: 0}}
                                                className='re-formgroup-label-sm'>Cascading filter</Typography>
                                            <CustomSwitch defaultChecked={false} inputProps={{ 'aria-label': 'custom design' }} />
                                        </Box>
                                        
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Box className="re-flex-between">
                                            <Typography component="label" style={{marginBottom: 0}}
                                                className='re-formgroup-label-sm'>Dynamic label</Typography>
                                            <CustomSwitch defaultChecked={false} inputProps={{ 'aria-label': 'custom design' }} />
                                        </Box>
                                        
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>

                                </Grid>

                                <Divider style={{margin: '30px -30px 0'}} />
                                <Box className="modal-footer-simple">
                                    <Button 
                                        // onClick={handleAddReportReset} 
                                        className="re-btn re-btn-outline mr-20px width-75p" variant="outlined" > Reset </Button>
                                    <Button 
                                        // onClick={handleAddReportSubmit}  
                                        autoFocus 
                                        className="re-btn re-btn-main width-75p" variant="contained"> Add </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Fade>
                </Modal>
            </Box>

            <Box className="report-filters-section">
                <DashboardGranularity
                    granularityOptions={granularityOptions}
                    addGranularityToSheet={addGranularityToSheet}
                    sheetsAvailable={sheetsAvailable}
                    setSheetsAvailable={setSheetsAvailable}
                    selectedSheetIndex={selectedSheetIndex}
                    applyGranularityToAllReports={applyGranularityToAllReports}
                    removeGranularityFrmAllReports={removeGranularityFrmAllReports}
                />
            </Box>
        </RootStyle>
    );
}
